import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';

import { ScrollService } from '../../services/scroll/scroll.service';
import { WindowRefService } from '../../services/window-ref/window-ref.service';

@Component({
  selector: 'app-scroll',
  templateUrl: './scroll.component.html',
  styleUrls: ['./scroll.component.scss']
})
export class ScrollComponent implements AfterViewInit, OnDestroy, OnInit {

    @ViewChild('scrollWrapper', {static: false}) scrollWrapper: ElementRef;

    constructor (private scroll: ScrollService, private renderer: Renderer2, private windowRef: WindowRefService) {}

    ngOnInit () {
        this.disablePageScroll(true);
    }

    ngAfterViewInit () {
        this.scroll.init(this.scrollWrapper.nativeElement);
    }

    ngOnDestroy () {
        this.disablePageScroll(false);
        this.scroll.destroy();
    }

    private disablePageScroll (add: boolean) {
        if (add) {
            this.renderer.addClass(this.windowRef.nativeWindow.document.documentElement, 'no-scroll');
            this.renderer.addClass(this.windowRef.nativeWindow.document.body, 'no-scroll');
        } else {
            this.renderer.removeClass(this.windowRef.nativeWindow.document.documentElement, 'no-scroll');
            this.renderer.removeClass(this.windowRef.nativeWindow.document.body, 'no-scroll');
        }
    }

}
